import { useSelector } from 'react-redux'
import { useIntl, defineMessages } from 'react-intl'
import { Flex, Button } from '@homebotapp/hb-react-component-catalog'
import history from '../../../../history'
import OverlayPanel from '../../Routing/OverlayPanel'
import AirDnaLearnMorePanel from './AirDnaLearnMorePanel'
import { ROUTE_KEY_BUY } from '../../../../constants/routes'
import { OVERLAY_HELPERS } from '../../../../constants/navigation'
import { selectRouteKey } from '../../../../store/selectors/routes'
import { BUYER_DIGEST_AIRDNA_MODULE } from '../../../../constants/tracking/trackingEventLocations/buyerDigestTrackingEventLocation'
import { HOMEOWNER_DIGEST_AIRDNA_MODULE } from '../../../../constants/tracking/trackingEventLocations/homeownerDigestTrackingEventLocation'

export const MSG = defineMessages({
  title: {
    id: 'Homeowners.overlay.airDna.learnMore.title',
    defaultMessage: 'Airbnb rental potential'
  },
  btn: {
    id: 'AirDna.additionalInfo.learnMore',
    defaultMessage: 'Can you help me learn more?'
  }
})

export const AirDnaLearnMoreButton = () => {
  const intl = useIntl()
  const routeKey = useSelector(selectRouteKey)

  const openLearnMorPanel = () => {
    history.push(OVERLAY_HELPERS.airDnaLearnMore.buildPath())
  }

  return (
    <>
      <OverlayPanel
        back={OVERLAY_HELPERS.airDnaLearnMore.getOrigin()}
        path={OVERLAY_HELPERS.airDnaLearnMore.buildPath()}
        title={intl.formatMessage(MSG.title)}
        component={AirDnaLearnMorePanel}
      />
      <Flex align='center' justify='center' marginTop={8}>
        <Button
          onClick={openLearnMorPanel}
          tracking={{
            guid: 'cxHHrnvqAQnnexpjv6Po8p',
            descriptor: MSG.btn.defaultMessage,
            ui_context: routeKey === ROUTE_KEY_BUY ? BUYER_DIGEST_AIRDNA_MODULE : HOMEOWNER_DIGEST_AIRDNA_MODULE
          }}
        >
          {intl.formatMessage(MSG.btn)}
        </Button>
      </Flex>
    </>
  )
}
